// extracted by mini-css-extract-plugin
module.exports = {"content":"userMostLike_content__38ZVr","smallScreenOnly":"userMostLike_smallScreenOnly__WqPHr"};